import AssetProviderLogo from './AssetProviderLogo';

export default AssetProviderLogo;
export { AssetProviderLogo };
